<template>
  <section class="hero-section-2 hero-2 hero-4">
    <div class="swiper-container relative">
      <!-- 导航按钮 -->
      <div class="swiper-button-prev image-arry banner-three__arry-prev"
        style="width: 64px !important; height: 64px !important;">
        <i class="fa-light fa-chevron-left"></i>
      </div>
      <div class="swiper-button-next image-arry banner-three__arry-next"
        style="width: 64px !important; height: 64px !important;">
        <i class="fa-light fa-chevron-right"></i>
      </div>

      <!-- Swiper 内容 -->
      <Swiper :modules="[SwiperAutoplay, SwiperEffectFade, SwiperNavigation, SwiperPagination]" :slides-per-view="1"
        :loop="true" :effect="'fade'" :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
        }" :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }" :pagination="{
          clickable: true,
          el: '.swiper-pagination'
        }" class="hero-slider-2" @swiper="onSwiper" @slideChange="onSlideChange">
        <SwiperSlide v-for="(slide, index) in slides" :key="index">
          <div class="hero-items">
            <div class="hero-bg bg-cover" :style="{ backgroundImage: `url(${slide})` }"></div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8">
                  <div class="hero-content">
                    <span :class="{ 'animate__animated animate__fadeInUp': activeIndex === index }"
                      style="font-size: 50px; color: white; animation-delay: 0.4s;">
                      {{ $t(titleKeys[index]) }}
                    </span>
                    <p :class="{ 'animate__animated animate__fadeInUp': activeIndex === index }"
                      style="margin-left: 0; animation-delay: 0.6s;">
                      {{ $t(descriptionKeys[index]) }}
                    </p>
                    <a :class="{ 'animate__animated animate__fadeInUp': activeIndex === index }" class="btn-one"
                      style="width: fit-content; animation-delay: 0.8s; cursor: pointer;" @click="showContact">
                      <span>{{ $t('sqtakf') }}</span>
                      <i class="fa-solid fa-angles-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>

      <!-- 分页指示器 -->
      <div class="swiper-pagination"></div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// 导出 Swiper 模块以供模板使用
const SwiperAutoplay = Autoplay
const SwiperEffectFade = EffectFade
const SwiperNavigation = Navigation
const SwiperPagination = Pagination

// 当前活跃的幻灯片索引
const activeIndex = ref(0)

// Swiper 实例
const swiperInstance = ref(null)

// 轮播图数据
const slides = ref([])
const { data: bannerList } = await useFetch<any>('/sre/resource/get', {
  baseURL: useRuntimeConfig().public.apiUrl,
  params: {
    key: 'home-banner'
  }
})

if (bannerList.value && bannerList.value.data) {
  slides.value = bannerList.value.data.value || ['/images/carousel/slide1.svg']
  console.log('slides.value', slides.value)
}

// 轮播图文本内容的国际化键名
const titleKeys = ['cc2qfy', '3w9yu4', '76fwyv']
const descriptionKeys = ['o80p2q', 'b5fn8q', '2ojpjz']

// Swiper 事件处理函数
const onSwiper = (swiper) => {
  swiperInstance.value = swiper
  activeIndex.value = swiper.realIndex
}

const onSlideChange = (swiper) => {
  activeIndex.value = swiper.realIndex
}

// 联系我们按钮点击事件
const showContact = () => {
  console.log('showContact')

  // 确保只在客户端执行
  if (import.meta.browser) {
    // Tawk_API.toggle()
    // // 尝试方法 2: 直接操作 iframe
    // const chatIframe = document.getElementById('s-chat-plugin')
    // console.log('聊天 iframe:', chatIframe)

    // if (chatIframe) {
    //   // 尝试方法 2.1: 尝试触发点击事件
    //   try {
    //     // 如果 iframe 和主页面同源，可以直接访问其内容
    //     const iframeDocument = chatIframe.contentDocument || chatIframe.contentWindow.document
    //     const chatButton = iframeDocument.querySelector('.view_btn_chat_pglag')

    //     if (chatButton) {
    //       console.log('在 iframe 中找到聊天按钮，尝试点击')
    //       chatButton.click()
    //       return
    //     }
    //   } catch (e) {
    //     console.log('无法访问 iframe 内容，可能是跨域限制:', e)
    //   }
    // }
  }
}
</script>

<style scoped>
/* Swiper 容器样式 */
.swiper-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* 导航按钮样式 */
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  display: none;
  /* 隐藏默认箭头 */
}

/* 分页指示器样式 */
.swiper-pagination {
  position: absolute;
  bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
}

.swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
  background-color: #fff;
  transform: scale(1.2);
}

/* 确保幻灯片内容正确显示 */
.hero-items {
  position: relative;
  width: 100%;
  height: 100vh;
  max-height: 800px;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.hero-content {
  position: relative;
  z-index: 2;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hero-2.hero-4 .hero-content p {
    margin: 0 auto 20px;
  }

  .hero-items {
    height: 40vh;
  }

  .hero-content span {
    font-size: 26px !important;
  }

  .hero-content p {
    font-size: 14px;
  }
}

/* 响应式调整 */
@media (max-width: 430px) {
  .hero-2.hero-4 .hero-content p {
    margin: 0 auto 20px;
  }

  .hero-items {
    height: 40vh;
  }

  .hero-content span {
    font-size: 20px !important;
    line-height: 28px;
  }

  .hero-content p {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
